import { render, staticRenderFns } from "./sub-partner.vue?vue&type=template&id=773cac90&scoped=true&"
import script from "./sub-partner.vue?vue&type=script&lang=js&"
export * from "./sub-partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773cac90",
  null
  
)

export default component.exports